import './GridLetterCard.css'
import React, {useContext, useEffect, useState} from "react";
import FlipCard from "./FlipCard/FlipCard.tsx";
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";

type GridLetterCardProps = {
    correctWord: string;
    wordList: string[];
    gameState: number;
    // 传递style样式
    style?: React.CSSProperties;
    isScreenshotting: boolean;
}

// 游戏中九宫格界面
const GridLetterCard: React.FC<GridLetterCardProps> = ({correctWord, wordList, gameState, style, isScreenshotting}) => {
    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    const [uuids, setUuids] = useState<string[]>([]);
    const scrollContainerRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        const newUuids: string[] = [...uuids];
        // 如果只是少1个，就添加一个就好了
        if (newUuids.length + 1 === wordList.length) {
            const uuid = Math.random().toString(36).substring(2, 15);
            setUuids([uuid,...newUuids]);
            return;
        }

        for (let i = 0; i < wordList.length; i++) {
            const uuid = Math.random().toString(36).substring(2, 15);
            newUuids.push(uuid);
        }
        setUuids([...newUuids])

    }, [wordList]);

    // useEffect(() => {
    //     if (isScreenshotting === true) {
    //         if (scrollContainerRef.current) {
    //             scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight
    //         }
    //     }
    //
    // }, [isScreenshotting]);


    return (
        <div
            className={`ai-challenge-grid-letter-card-container ${gameState === 3 ? 'ai-scale-game-grid ai-grid-height-after-scale' : ''}`}
            style={style}>
            <div className={`display-flex-column width-280 height-100-percent flex-direction-column-reverse display-flex-align-items-center overflow-y-auto`} ref={scrollContainerRef}>
                {wordList.length > 0 ? wordList.map((word, wordIndex) => {
                        const letters: string[] = word.toUpperCase().split('');
                        return (<div key={word + wordIndex + (uuids[wordIndex] ?? "") }
                                     className={`ai-letter-item  ${gameState == 3 ? 'ai-scale-game-grid' : ''} ${wordIndex !== wordList.length - 1 ? 'ai-grid-item-margin-top' : ''} ${wordIndex === 0 && isScreenshotting ? 'margin-bottom-50' : ''}  slide-up-animation`}>
                            {letters.map((letter, letterIndex) => {
                                return <FlipCard key={letter + letterIndex + wordIndex.toString()} isFlip={wordIndex == 0}
                                                 index={letterIndex} uuid={uuids[wordIndex] ?? ""}
                                                 letter={letter} correctWord={correctWord}/>
                            })}
                        </div>)
                    }) :
                    <div className="no-data-container">
                        <img className="word-tip-img" src={imgUrls.gridNoDataImgUrl} alt="tips"/>
                        <div className="word-text my-roboto-regular">Please enter a <span className="color-blue">five-letter</span> word to start!
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default GridLetterCard;